// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".exchang[data-v-8beb72f0]{margin:1.041667rem 0}.exchang[data-v-8beb72f0],.exchang img[data-v-8beb72f0]{text-align:center}", ""]);
// Exports
module.exports = exports;
